import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/(app)/_auth/settings/communication/templates",
)({
  loader: () => ({
    crumb: "alfred.settings.nav.communicationTemplates.label",
  }),
})
